import React from "react";
import { Backdrop, CircularProgress, styled } from "@mui/material";
import { useSelector } from "react-redux";

// Define your custom styles using styled-components
const StyledBackdrop = styled(Backdrop)`
  && {
    z-index: 9999;
    color: #fff;
  }
`;

const Loader = () => {
  const isAuthLoading = useSelector((state: any) => state.auth?.isLoading);
  const isProfileLoading = useSelector((state: any) => state.profiles?.isLoading);
  const isLoading = !!isAuthLoading || !!isProfileLoading;
  return (
    <StyledBackdrop open={isLoading}>
      <CircularProgress color="primary" />
    </StyledBackdrop>
  );
};

export default Loader;
